export function getNonEmptyString(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function getObjectString(source: unknown, key: string): string | null {
  if (!source || typeof source !== 'object') {
    return null;
  }
  return getNonEmptyString((source as Record<string, unknown>)[key]);
}

export function pickObjectString(source: unknown, keys: readonly string[]): string | null {
  for (const key of keys) {
    const value = getObjectString(source, key);
    if (value) {
      return value;
    }
  }
  return null;
}
